var toString = require('./toString');
module.exports = function isError(obj){return toString.call(obj) === '[object Error]';};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isError.js
 ** module id = 14
 ** module chunks = 0
 **/